import $ from 'jquery';
import hiddenBox from '@ui/hidden-box';

export const elements = {
    item    : '.js-MainNavigation-Item',
    holder  : '.js-MainNavigation-Holder',
    submenu : '.js-MainNavigation-Submenu'
};

export const getElements = (context) => {
    const $this = $(context);
    const $submenu = $this.find(elements.submenu);
    const $holder = $this.parents(elements.holder);

    return { $submenu, $holder };
}

export const mouseenter = function() {
    const { $submenu, $holder } = getElements(this);

    if ($(window).width() > 767) {
      $holder.addClass('fn-active');

      $holder.find(elements.item).removeClass('fn-active');
      $holder.find(elements.submenu).removeClass('fn-active');

      $(this).addClass('fn-active');
      $submenu.addClass('fn-active');
    }
};

export const mouseleave = function(event) {
    const { $submenu, $holder } = getElements(this);

    if ($(window).width() > 767) {
        const $this = $(this);
        const top = $this.offset().top;
        const height = $this.outerHeight();
        const mouseY = event.originalEvent.pageY;
        const left = $this.offset().left;
        const width = $this.outerWidth();
        const mouseX = event.originalEvent.pageX;

        if (mouseY < top || mouseY > (top + height + 5) || mouseX < left || mouseX > (left + width - 5)) {
            $holder.removeClass('fn-active');
            $this.removeClass('fn-active');
            $submenu.removeClass('fn-active');
        }
    }
};

export default {
    init(params) {
        params.$document.find(elements.item).on({ mouseenter, mouseleave });
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/menu/desktop.js